import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GameCountDown = styled.div`
  font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '12px')};
  color: white;
`;

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '300px' : '100px')};
  height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '300px' : '100px')};
  font: ${({ windowsWidth }) => (windowsWidth >= 500 ? '100px' : '50px')} Arial, sans-serif;
  color: white;
  border-radius: 50%;
  border: 8px solid white;
`;

const ReadySetGo = styled.h1`
  font: ${({ windowsWidth }) => (windowsWidth >= 500 ? '60px' : '40px')} Arial, sans-serif;
  color: white;
`;

const BeforeReadySetGo = styled.h1`
  font: ${({ windowsWidth }) => (windowsWidth >= 500 ? '60px' : '40px')} Arial, sans-serif;
  color: rgba(0, 0, 0, 0.0);
`;

const Hint = styled.p`
  text-align: center;
  font-size: 2.5vh;
  line-height: 1.5em;
  color: white;
`;

const BeforeGameCountDown = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

/**
 * This compoent is used for two different parts:
 *
 * The first part is for shwoing 5 seconds count down timer of the top right of the game's page
 *
 * The seond part is for showing 5 seconds count down timer before start of the game with
 * context of Ready, Set, Go!
 *
 */

const SecondsCounter = ({ seconds, isBeforeGame, windowsWidth }) => (
  <Container>
    {!isBeforeGame && (
      <GameCountDown windowsWidth={windowsWidth}>
        {'00:'}
        {seconds}
      </GameCountDown>
    )}
    <BeforeGameCountDown>
      {isBeforeGame && (
        <>
          <Circle>
            {seconds}
          </Circle>
          <Hint>{_('recycleRight.answer_less_than_five_seconds')}</Hint>
        </>
      )}
      {isBeforeGame && seconds !== '02' && seconds !== '01' && seconds !== '00' && (
        <BeforeReadySetGo>{_('recycleRight.ready')}</BeforeReadySetGo>
      )}
      {isBeforeGame && seconds === '02' && (
        <ReadySetGo>{_('recycleRight.ready')}</ReadySetGo>
      )}
      {isBeforeGame && seconds === '01' && (
        <ReadySetGo>{_('recycleRight.set')}</ReadySetGo>
      )}
      {isBeforeGame && seconds === '00' && (
        <ReadySetGo>{_('recycleRight.go')}</ReadySetGo>
      )}
    </BeforeGameCountDown>
  </Container>
);

export default SecondsCounter;
